import { Component, OnInit } from '@angular/core';
import { BrokerService } from './core/services/broker.service';
import { SesionService } from './core/services/sesion.service';
import { content } from './core/interface/content.interface';
import { environment } from '../environments/environment';
import { CanActiveViaAuthGuard } from './core/services/auth-guard.service';

declare var $: any;
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'o_pntd_a13_ui';
  txt: any;
  constructor(
    private broker: BrokerService,
    private sesion: SesionService,
    private guard: CanActiveViaAuthGuard) {

    // const serlefin = document.createElement('script');
    // serlefin.src = 'https://m.serlefin.com/SerlefinWidget/JS/SerlefinWidget.js?v=1';
    // // serlefin.innerHTML = `<iframe src="https://m.serlefin.com/SerlefinWidget/JS/SerlefinWidget.js?v=1a"></iframe>`;
    // document.head.appendChild(serlefin);
    if (this.sesion.sesionCookie) {
      // var serlefin = document.createElement('script');
      // serlefin.type = 'text/javascript';
      // serlefin.id = 'serlefinChat'
      // serlefin.innerHTML = `new SerlefinWidget(
      //   'https://m.serlefin.com/LEX/WChat',
      //   'BQr9ugMnJj7SYBBt2xPeMdmDH5NbBejnGXt7nmAzLyVUY4b5WtbzRKRBchSWuUgW',
      //   'assets/images/chat/D_Serlefin_Azul-2.png',
      //   'https://m.serlefin.com/LEX/CSS/SerlefinWidget.css', 
      //   null);`;
      // document.body.appendChild(serlefin);
    }

    if (environment.gtmPruebas) {

      // use safe script insertion rather than innerHTML
      const j = document.createElement('script');
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-5X3WN5M';
      const f = document.getElementsByTagName('script')[0];
      if(f && f.parentNode){ f.parentNode.insertBefore(j,f); } else { document.head.appendChild(j); }

      const nos = document.createElement('iframe');
      nos.width = '0';
      nos.height = '0';
      nos.style.display = 'none';
      nos.style.visibility = 'hidden';
      nos.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5X3WN5M';
      document.body.appendChild(nos);
    } else {

      const j = document.createElement('script');
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-M8HR8J9';
      const f = document.getElementsByTagName('script')[0];
      if(f && f.parentNode){ f.parentNode.insertBefore(j,f); } else { document.head.appendChild(j); }

      const nos = document.createElement('iframe');
      nos.width = '0';
      nos.height = '0';
      nos.style.display = 'none';
      nos.style.visibility = 'hidden';
      nos.src = 'https://www.googletagmanager.com/ns.html?id=GTM-M8HR8J9';
      document.body.appendChild(nos);

      ///// Hotjar Tracking Code for https://www.midatacredito.com 
        // safe hotjar inclusion
        const hj = document.createElement('script');
        hj.async = true;
        hj.src = 'https://static.hotjar.com/c/hotjar-1601850.js?sv=6';
        const fh = document.getElementsByTagName('script')[0];
        if(fh && fh.parentNode){ fh.parentNode.insertBefore(hj, fh); } else { document.head.appendChild(hj); }
    }
  }

  ngOnInit() {
    this.broker.contenido_interface().subscribe((response: any) => {
      this.txt = response;
      this.sesion.datos = response;
    }, (error) => {
    });
    //Validar sesión
    this.sesion.getCookie();
    if (this.sesion.sesionCookie) {
      window.location.href = environment.urlMidc;
    }
  }
}
